import type { FaireProductEntity } from "../../entity_types/product";

export const p_677wpq5eyh: FaireProductEntity = {
  token: "p_677wpq5eyh",
  type: "product",
  name: 'ORGANIC COTTON KNOTTED GOWN IN "OAT"',
  brandToken: "b_ffc53wbmve",
  brandName: "Chubby Lamb",
  imageUrl:
    "https://cdn.faire.com/fastly/831527dfbaf9683efee7216dad5c0c02e35aa538074b90c4b19b5b896fbf3b15.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1d9269d5e51611409c823459bb2929451f9108ef7d0720605829d0fd609e8a6e.jpeg",
    "https://cdn.faire.com/fastly/2e90077613980b0078cd8e222d361e9d7e2d85642150296fe49e51c9c940b54e.jpeg",
    "https://cdn.faire.com/fastly/437092a2fa7dd2cc4e36600c2437e3bc388cd2c4b73b866580e68a6287ccab07.jpeg",
  ],
  priceDollars: 19.5,
  description:
    "\nThe Snuggle Is Real!\n\nThese Beautiful Knotted Gowns Come In 5 Colors. The Easiest Outfit To Dress Your Littlest One! Simple Tie Closure Ensures Easy Diaper Changes. Made With 100% Organic Cotton & Optional Fold Over Cuffs.\n\n * 2 optional front button closures \n * Crew neck \n * Optional fold over cuffs \n * Breathable ribbed knit stretch \n * Made with 100% GOTS certified organic cotton \n * Ethically sourced & produced \n * Machine wash cold \n \n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:25.404Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
